import classNames from "classnames";
import Button from "components/Leasing/components/leasing.c.button";
import {
  prePareQueryRequest,
  getLastItem,
} from "components/Leasing/utils/leasing.u";
import { differenceInDays, format } from "date-fns";
import _ from "lodash";
import { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { Auth, API } from "aws-amplify";
import axios from "axios";
import numeral from "numeral";
import { getCurrentLocalDateTime, pad } from "../../../utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let source = axios.CancelToken.source();

function AutoMail({ sandboxDate, typeCreate = "REAL", texts = [] }) {
  const [loading, setLoading] = useState(false);
  const [autoMail, setAutoMail] = useState([]);
  const [count, setCount] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (finished) {
      const doc = document.getElementById(
        `export-excel-leasing-autoMail-${typeCreate}`
      );
      doc.click();
    }
  }, [finished]);

  const getDefaultQuery = () => {
    const objQuery = {
      Limit: 1,
      loan_id: "",
      ScanIndexForward: false,
      status: "",
      category: "",
      min: "",
      max: "",
      fields: "",
    };
    return objQuery;
  };

  const fetchLeasingLoan = async () => {
    try {
      setLoading(true);
      setFinished(false);
      setCount(0);

      const today = getCurrentLocalDateTime(new Date(sandboxDate));

      let pathName = "/loanRequest/reportInterfaceCreate";
      if (typeCreate === "ONE") {
        pathName = "/reportCreateOne";
      } else if (typeCreate === "TWO") {
        pathName = "/reportCreateSecond";
      } else if (typeCreate === "THREE") {
        pathName = "/reportCreateThird";
      }

      const data = await API.get("MoneyHubAdmin", pathName, {
        queryStringParameters: {
          valueDate: `${today.year}${pad(today.month)}${pad(today.date)}`,
          date: `${today.year}-${pad(today.month)}-${pad(today.date)}`,
          sendEmail: false,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
        cancelToken: source?.token,
      });

      setAutoMail(data?.leasingCreates);
      setFinished(true);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoading(false);
    }
  };

  const styleColumn = {
    fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } },
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    borders: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    let style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      style = {
        ...style,
        fill: filled,
      };
      result.push([
        {
          style,
          value: i + 1,
        },
        {
          style,
          value: data[i]?.REFERENCE,
        },
        {
          style,
          value: data[i]?.TITLE,
        },
        {
          style,
          value: data[i]?.NAME,
        },
        {
          style,
          value: data[i]?.MOBILE_PHONE,
        },
        {
          style,
          value: data[i]?.TAX_ID,
        },
        {
          style,
          value: data[i]?.CONTRACT_TYPE,
        },
        {
          style,
          value: data[i]?.LOAN_AMOUNT,
        },
        {
          style,
          value: data[i]?.CURRENCY,
        },
        {
          style,
          value: data[i]?.PAYMENT_DOC_DATE,
        },
        {
          style,
          value: data[i]?.PAYMENT_POST_DATE,
        },
        {
          style,
          value: data[i]?.VALUE_DATE,
        },
        {
          style,
          value: data[i]?.REGISTRATION_TYPE,
        },
        {
          style,
          value: data[i]?.EMAIL,
        },
        {
          style,
          value: data[i]?.ADDRESS,
        },
        {
          style,
          value: data[i]?.REGION,
        },
        {
          style,
          value: data[i]?.POSTAL_CODE,
        },
        {
          style,
          value: data[i]?.BANK_KEY,
        },
        {
          style,
          value: data[i]?.BANK_ACCOUNT,
        },
        {
          style,
          value: data[i]?.BANK_TYPE,
        },
        {
          style,
          value: data[i]?.ACCT_HOLDER,
        },
        {
          style,
          value: data[i]?.CUSTOMER_PAY_TERM,
        },
        {
          style,
          value: data[i]?.VENDOR_PAY_TERM,
        },
        {
          style,
          value: data[i]?.BRANCH_CODE,
        },
        {
          style,
          value: data[i]?.COMPANY_CODE,
        },
        {
          style,
          value: data[i]?.MESSAGE,
        },
        {
          style,
          value: data[i]?.MESSAGE_TYPE,
        },
        {
          style,
          value: data[i]?.sendSapAt,
        },
        {
          style,
          value: data[i]?.VENDOR_AMOUNT || "-",
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "NO.",
          width: { wch: 16 },
          style: styleColumn,
        },
        {
          title: "REFERENCE",
          width: { wch: 24 },
          style: styleColumn,
        },
        {
          title: "TITLE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "NAME",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "MOBILE_PHONE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "TAX_ID",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "CONTRACT_TYPE",
          width: { wch: 24 },
          style: styleColumn,
        },
        {
          title: "LOAN_AMOUNT",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "CURRENCY",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "PAYMENT_DOC_DATE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "PAYMENT_POST_DATE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "VALUE_DATE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "REGISTRATION_TYPE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "EMAIL",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "ADDRESS",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "REGION",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "POSTAL_CODE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "BANK_KEY",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "BANK_ACCOUNT",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "BANK_TYPE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "ACCT_HOLDER",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "CUSTOMER_PAY_TERM",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "VENDOR_PAY_TERM",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "BRANCH_CODE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "COMPANY_CODE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "MESSAGE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "MESSAGE_TYPE",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "วันที่ส่ง SAP",
          width: { wch: 34 },
          style: styleColumn,
        },
        {
          title: "VENDOR_AMOUNT",
          width: { wch: 34 },
          style: styleColumn,
        },
      ],
      data: createDataWithStyle(autoMail),
    },
  ];

  return (
    <div>
      <Button
        disabled={loading}
        loading={loading}
        onClick={fetchLeasingLoan}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
      >
        {loading ? (
          `Loading... ${count}`
        ) : (
          <div className="flex flex-col items-start">
            {texts?.map((text) => {
              return <div>{text}</div>;
            })}
          </div>
        )}
      </Button>

      <ExcelFile
        filename={`LEASING_INTERFACE_CREATE_${typeCreate}_${format(
          new Date(),
          "yyyy-MM-dd"
        )}`}
        element={
          <button
            id={`export-excel-leasing-autoMail-${typeCreate}`}
            hidden
          ></button>
        }
      >
        <ExcelSheet
          dataSet={multiDataSet}
          name={`LEASING_INTERFACE_CREATE_${typeCreate}`}
        ></ExcelSheet>
      </ExcelFile>
    </div>
  );
}

export default AutoMail;
